import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

import { externalLink } from "@/routes/_constants";

import { buttonVariants } from "@/components/ui/button/button";
import OpenInNew from "@/components/ui/icon/open-in-new";

type Props = {
	hotelID: string;
};

export const ProductFeedbackLink = memo(({ hotelID }: Props) => {
	return (
		<div className="mt-10 flex flex-col items-center gap-3 border-t border-zinc-200 pt-8 text-center">
			<p className="text-sm text-zinc-600">ご意見・ご感想はこちらからお寄せください。</p>
			<a
				href={externalLink.feedbackSiteUrl(hotelID)}
				target="_blank"
				rel="noopener noreferrer"
				className={cn(buttonVariants(), "h-auto min-h-10 gap-2 px-6 py-2")}
			>
				サービスや機能についての改善要望
				<OpenInNew size="sm" className="shrink-0" />
			</a>
		</div>
	);
});

ProductFeedbackLink.displayName = "ProductFeedbackLink";
